var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcImport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7169 18.5412H7.28356C3.19189 18.5412 1.44189 16.7912 1.44189 12.6996V12.5912C1.44189 8.89124 2.90023 7.10791 6.16689 6.79957C6.50023 6.77457 6.81689 7.02457 6.85023 7.36624C6.88356 7.70791 6.63356 8.01624 6.28356 8.04957C3.66689 8.29124 2.69189 9.52457 2.69189 12.5996V12.7079C2.69189 16.0996 3.89189 17.2996 7.28356 17.2996H12.7169C16.1086 17.2996 17.3086 16.0996 17.3086 12.7079V12.5996C17.3086 9.50791 16.3169 8.27457 13.6502 8.04957C13.3086 8.01624 13.0502 7.71624 13.0836 7.37457C13.1169 7.03291 13.4086 6.77457 13.7586 6.80791C17.0752 7.09124 18.5586 8.88291 18.5586 12.6079V12.7162C18.5586 16.7912 16.8086 18.5412 12.7169 18.5412Z",
    fill: "#13BA7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.0253C9.65833 13.0253 9.375 12.742 9.375 12.4003V1.66699C9.375 1.32533 9.65833 1.04199 10 1.04199C10.3417 1.04199 10.625 1.32533 10.625 1.66699V12.4003C10.625 12.7503 10.3417 13.0253 10 13.0253Z",
    fill: "#13BA7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9585C9.8417 13.9585 9.68337 13.9002 9.55837 13.7752L6.7667 10.9835C6.52503 10.7419 6.52503 10.3419 6.7667 10.1002C7.00837 9.85853 7.40837 9.85853 7.65003 10.1002L10 12.4502L12.35 10.1002C12.5917 9.85853 12.9917 9.85853 13.2334 10.1002C13.475 10.3419 13.475 10.7419 13.2334 10.9835L10.4417 13.7752C10.3167 13.9002 10.1584 13.9585 10 13.9585Z",
    fill: "#13BA7F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_import.35c662e7.svg";
export { ForwardRef as ReactComponent };